
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/fullstory",
      function () {
        return require("private-next-pages/destinations/fullstory.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/fullstory"])
      });
    }
  